document.addEventListener('DOMContentLoaded', () => {
  const modals = document.querySelectorAll('.promo-modal');

  modals.forEach(modal => {
    const modalId = modal.dataset.modalId;
    const showOnce = modal.dataset.showOnce !== 'false';

    if (showOnce && localStorage.getItem(`promo_modal_${modalId}`)) {
      return;
    }

    setTimeout(() => {
      modal.classList.add('is-active');
      document.body.classList.add('promo-modal-open');

      if (showOnce) {
        localStorage.setItem(`promo_modal_${modalId}`, 'true');
      }
    }, 800);
  });

  document.addEventListener('click', e => {
    if (
      e.target.classList.contains('promo-modal__close') ||
      e.target.classList.contains('promo-modal__overlay')
    ) {
      const modal = e.target.closest('.promo-modal');
      modal.classList.remove('is-active');
      document.body.classList.remove('promo-modal-open');
    }
  });
});
